// Import Dependencies
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Import utilities
import { getClassNames } from '../../../utils';

export class ImageLoader extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
    };
  }

  componentDidMount() {
    const { image } = this.props;
    this.img = new Image();

    this.img.onload = this.handleImageLoad;
    if (image) this.img.src = image;
  }

  componentDidUpdate() {
    const { image } = this.props;
    if (image) this.img.src = image;
  }

  handleImageLoad = () => {
    this.setState({
      isLoaded: true,
    });
  };

  render() {
    const {
      image, alt, dark, ...props
    } = this.props;
    const { isLoaded } = this.state;

    return (
      <figure
        className={getClassNames(props, 'c-image  g-split-image__content', {
          'c-image--dark': dark,
        })}
      >
        <div className="c-image__container">
          <div className="g-split-image__layer">
            <div
              className={getClassNames(props, 'c-image__background  g-split-image__pic', {
                'is-lazyloaded': isLoaded,
              })}
              style={{ backgroundImage: `url(${isLoaded && image})` }}
            >
              <picture>
                <img src={image} alt={alt} />
              </picture>
            </div>
          </div>

          <div className="g-split-image__layer">
            <div
              className={getClassNames(props, 'c-image__background  g-split-image__pic', {
                'is-lazyloaded': isLoaded,
              })}
              style={{ backgroundImage: `url(${isLoaded && image})` }}
            />
          </div>

          <div className="g-split-image__layer">
            <div
              className={getClassNames(props, 'c-image__background  g-split-image__pic', {
                'is-lazyloaded': isLoaded,
              })}
              style={{ backgroundImage: `url(${isLoaded && image})` }}
            />
          </div>

          <div className="g-split-image__layer">
            <div
              className={getClassNames(props, 'c-image__background  g-split-image__pic', {
                'is-lazyloaded': isLoaded,
              })}
              style={{ backgroundImage: `url(${isLoaded && image})` }}
            />
          </div>

          <div className="g-split-image__layer">
            <div
              className={getClassNames(props, 'c-image__background  g-split-image__pic', {
                'is-lazyloaded': isLoaded,
              })}
              style={{ backgroundImage: `url(${isLoaded && image})` }}
            />
          </div>

        </div>
      </figure>
    );
  }
}

ImageLoader.propTypes = {
  alt: PropTypes.string,
  dark: PropTypes.bool,
  image: PropTypes.string.isRequired,
};

ImageLoader.defaultProps = {
  alt: null,
  dark: false,
};

export default ImageLoader;
